import React from 'react';

// Components
import { WpPageHeader } from 'Wpds/components/page-layout';
import { WpAvatar } from 'Wpds/components/avatar';

// Styles
import './ReviewsPageHeader.scss';

type Props = {
  avatar?;
  title: string;
  buttons?: React.ReactNode;
  tabs?: React.ReactNode;
  sticky?: boolean;
};

const ReviewsPageHeader = ({ avatar, title, buttons, tabs = null, sticky = true }: Props) => {
  const baseClassName = 'ReviewsPageHeader';
  return (
    <WpPageHeader width="container" sticky={sticky}>
      <div className={baseClassName}>
        {avatar && (
          <div className={`${baseClassName}__avatar`}>
            <WpAvatar avatar={avatar} />
          </div>
        )}
        <h5 className={`${baseClassName}__title`}>{title}</h5>
        {buttons && <>{buttons}</>}
      </div>
      {tabs}
    </WpPageHeader>
  );
};

export default ReviewsPageHeader;
